// src/components/Login/Login.tsx
import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import '../../styles/login.css';
import { useAuth } from '../../auth/AuthContext';

const Login: React.FC = () => {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname || '/dashboard';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка входа');
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>🤖 FleetCore</h1>
        <p className="login-subtitle">Вход в панель управления роботами</p>

        <label htmlFor="username">Логин</label>
        <input
          id="username"
          name="username"
          autoComplete="username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          autoFocus
        />

        <label htmlFor="password">Пароль</label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        {error && <div className="login-error" role="alert">{error}</div>}

        <button type="submit" className="login-btn" disabled={submitting}>
          {submitting ? 'Вход...' : 'Войти'}
        </button>
      </form>
    </div>
  );
};

export default Login;
